import { MESSAGE_CHANNEL } from "../../../packages/constants";
import { helpers } from "../../../packages/helpers";
import { getStringValue } from "../../../packages/helpers/text";
import { AppStore } from "../../../store";
import { selectUserId } from "../../auth/selectors";
import { setTabTitleUpdateIntervalId } from "../../chat/actions";
import { DICTIONARY } from "../../chat/dictionary";
import { getMessagesData } from "../../chat/providers";
import {
  selectDefaultTabTitle,
  selectOperatorName,
  selectTabTitleUpdateIntervalId,
} from "../../chat/selectors";
import { GetMessagesResponse } from "../../chat/types";

const { showNotification } = helpers.notifications;
const { sanitizeToPlainText } = helpers.text;

const handleTabTitleChange = ({
  getState,
  dispatch,
}: {
  getState: AppStore["getState"];
  dispatch: AppStore["dispatch"];
}) => {
  const defaultTitle = selectDefaultTabTitle(getState());
  const intervalId = selectTabTitleUpdateIntervalId(getState());

  if (intervalId) {
    clearInterval(intervalId);
  }

  const newTabTitleUpdateIntervalId = setInterval(() => {
    document.title =
      document.title === defaultTitle
        ? DICTIONARY.TAB_NEW_MESSAGE_TITLE
        : defaultTitle;
  }, 1000);

  dispatch(setTabTitleUpdateIntervalId(Number(newTabTitleUpdateIntervalId)));
};

export const showNotificationHandler = (
  { getState, dispatch }: AppStore,
  msg: GetMessagesResponse["data"]
) => {
  const userId = selectUserId(getState());
  const messages = getMessagesData(msg?.messages, MESSAGE_CHANNEL.SSE);
  const messageAuthorId = messages?.[0]?.authorId;
  const messageText = getStringValue(messages?.[0]?.content?.text);

  const isOperatorMessage =
    userId !== messageAuthorId && messages?.[0]?.type === "text";

  const operatorName = selectOperatorName(getState());

  if (isOperatorMessage && document.hidden) {
    showNotification({ operatorName, text: sanitizeToPlainText(messageText) });
    handleTabTitleChange({ getState, dispatch });
  }
};
